import React, { useEffect } from "react";
import WorkplaceConsultancyImg from '../Images/WorkplaceConsultancy.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function WorkplaceConsultancy() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={WorkplaceConsultancyImg} alt="Engineering" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 md:py-8 px-4 md:px-14">
                    <h1 className="text-white text-2xl md:text-4xl font-bold">Workplace Consultancy</h1>
                </div>
            </div>
            <div className="p-4 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <h1 className="text-xl md:text-2xl mb-4 tracking-wider">
                        Workplace Consultancy at Architetive Designs
                    </h1>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        We have a multidisciplinary group of specialists in workplace architecture, environmental psychology, wellness, hospitality, and healthcare design who help align leadership decision-making and business priorities with design. By defining spaces and technologies that help people work better and smarter, we create an environment that will see organisations thrive and retain their relevance and vitality.
                    </p>
                </div>
                <div className="flex flex-row gap-4">
                    <Link to='/people'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">People</button>
                    </Link>
                    <Link to='/contact'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Contact</button>
                    </Link>
                    <Link to='/careers/vacancies'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Vacancies</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default WorkplaceConsultancy;